// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qNnZE","top":"styles_top__1Kx4Y","left":"styles_left__1YZII","description":"styles_description__1bsrJ"};